import type { ReactNode } from 'react';

export function LoadingState({ label = '正在加载…' }: { label?: string }) {
  return (
    <div className="state-panel" role="status">
      <span className="spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="state-panel state-panel--empty">
      <div className="state-panel__mark" aria-hidden="true">ZQ</div>
      <h2>{title}</h2>
      <p>{description}</p>
      {action}
    </div>
  );
}

export function ErrorState({
  title = '暂时无法加载',
  description,
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="state-panel state-panel--error" role="alert">
      <h2>{title}</h2>
      <p>{description ?? '请检查网络后重试，已输入的内容不会被主动清空。'}</p>
      {onRetry && <button className="button button--secondary" onClick={onRetry}>重新加载</button>}
    </div>
  );
}
